import { Component } from "@angular/core";
import {AlertController, App, LoadingController, NavController, NavParams, ViewController} from "ionic-angular";
import {DomSanitizer} from "@angular/platform-browser";
import {AppDialog} from "../../component/appDialog";
import {HabaServices} from "../../services/haba.services";
import {HabaGames} from "../habaGames/habaGames";
import {TabsPage} from "../tabs/tabs";

@Component({
    templateUrl: 'habaGamesPlay.html',
    selector: 'haba-games-play'
})

export class HabaGamesPlay {
    private titleGame: string = '';
    private trustedUrl: any;
    private loading: any;
    private timeInterValLoadBalance: any;

    constructor(private navParams: NavParams, public loadingCtrl: LoadingController, private sanitizer: DomSanitizer, private habaServices: HabaServices, private alertCtrl: AlertController, private app: App, private nav: NavController, private viewCtrl: ViewController) {
        let getData = navParams.data;
        this.titleGame = getData.title;
        this.loading = loadingCtrl.create({content: ''});
        this.loading.present();
        this.trustedUrl = this.sanitizer.bypassSecurityTrustResourceUrl(getData.link+'&ifrm=1');
    }

    webLoad(event) {
        this.loading.dismiss().catch(() => {});
    }

    ionViewWillEnter() {
        this.loadBalance();
        this.timeInterValLoadBalance = setInterval(() => {
            this.loadBalance();
        }, 10000);
    }

    ionViewWillLeave() {
        clearInterval(this.timeInterValLoadBalance);
    }

    loadBalance() {
        this.habaServices.habaGetBalance({}, {}).then(data => {
            if (data["sessionToken"] === "") {
                clearInterval(this.timeInterValLoadBalance);
                AppDialog.alert({
                    alertCtrl: this.alertCtrl,
                    message: "Phiên chơi game của bạn đã hết. Chọn 'OK' để đăng nhập lại.",
                    callBack: () => {
                        this.habaServices.habaLogin({}, this).then(data => {
                            if (data['msg'] === '') {
                                this.nav.push(HabaGames, {
                                    data: data
                                }).then(() => {
                                    let index = this.viewCtrl.index;
                                    this.nav.remove(index);
                                });
                            }else {
                                AppDialog.alert({
                                    alertCtrl: this.alertCtrl,
                                    message: data['msg'],
                                    callBack: () => {
                                        this.nav.push(TabsPage, {selectTab: 1}).then(() => {
                                            let index = this.viewCtrl.index;
                                            this.nav.remove(index);
                                        });
                                    }
                                });
                            }
                        });
                    }
                });
            }
        });
    }
}


// WEBPACK FOOTER //
// ./src/pages/habaGamesPlay/habaGamesPlay.ts